<template>
  <div>
    <div class="container marketing">
      <div class="row">
        <h2 class="title1">点击下方APP获取详情</h2>
        <div class="col-lg-3"
             v-for="item in imgList"
             :key="item.appName"
             @click="goService(item.appName)">
          <a-card hoverable>
            <img slot="cover"
                 alt="example"
                 :src="item.img" />
            <a-card-meta>
              <template slot="description">
                <h2>{{ item.appName }}</h2>
              </template>
            </a-card-meta>
          </a-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      imgList: [
        {
          img: require("../assets/images/fb_logo.svg"),
          appName: "facebook",
        },
        {
          img: require("../assets/images/instagram.svg"),
          appName: "instagram",
        },
        {
          img: require("../assets/images/tiktok-logo.svg"),
          appName: "tiktok",
        },
        {
          img: require("../assets/images/twitter_logo.svg"),
          appName: "twitter",
        },
        {
          img: require("../assets/images/snapchat.webp"),
          appName: "snapchat",
        },
        {
          img: require("../assets/images/youtube1.png"),
          appName: "youtube",
        },
        {
          img: require("../assets/images/telegram.png"),
          appName: "telegram",
        },
        {
          img: require("../assets/images/spotify.jpg"),
          appName: "spotify",
        },
        {
          img: require("../assets/images/pinterest.png"),
          appName: "printerest",
        },
        {
          img: require("../assets/images/other.png"),
          appName: "other",
        }
      ],
    };
  },
  methods: {
    goService (name) {
      this.$store.commit("setName", name);
      this.$router.push("/Service");
    },
  },
};
</script>
<style scoped>
.marketing {
  margin-top: 80px;
}
.marketing .col-lg-3 {
  margin-bottom: 20px;
  text-align: center;
  cursor: pointer;
}
.title1 {
  font-size: 34px;
  color: var(--text-color-darker);
  text-align: center;
  font-weight: 500;
}

.title1::after {
  content: "";
  display: block;
  width: 6%;
  height: 4px;
  background-color: var(--primary-color);
  margin: 14px auto 30px;
  transform: translateX(10%);
}
.ant-card-bordered {
  border: none;
  margin: 0 auto;
  padding-left: 10px;
  display: flex;
  align-items: center;
}
.ant-card-cover > * {
  width: 40px;
  height: 40px;
  margin: auto;
}

.ant-card-bordered h2 {
  font-size: 14px;
}

/deep/ .ant-card-bordered .ant-card-body {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

</style>

